import { render, staticRenderFns } from "./BookAmenity.vue?vue&type=template&id=06efc18a&"
import script from "./BookAmenity.vue?vue&type=script&lang=js&"
export * from "./BookAmenity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports